/**
 * Botón para pausar/reanudar la reproducción automática de audio
 */

import './PauseButton.css';

interface PauseButtonProps {
  isPaused: boolean;
  onToggle: () => void;
}

export function PauseButton({ isPaused, onToggle }: PauseButtonProps) {
  return (
    <button
      className="pause-button"
      onClick={onToggle}
      aria-label={isPaused ? 'Reanudar audio' : 'Pausar audio'}
      title={isPaused ? 'Reanudar audio' : 'Pausar audio'}
    >
      <img
        src={isPaused ? '/assets/chat-ui/botonplay.png' : '/assets/chat-ui/botonpausa.png'}
        alt={isPaused ? 'Reanudar' : 'Pausar'}
        className="pause-icon"
      />
    </button>
  );
}
